module.exports = __webpack_public_path__ + "static/fke-6e3f7b0a775962fbb5374e8a52a41349.png";